import { ChartSettingsT } from 'business/definitions';
import { PaletteName, COLOR_GRADIENTS } from 'styles/theme';

export const getGoalValueColor = (
    useGradientColor: boolean,
    reverseGradientColor: boolean,
    palette: PaletteName | undefined,
    color: string[],
) => {
    if (!useGradientColor || !palette) {
        return color[0];
    }
    const gradient = COLOR_GRADIENTS[palette];
    return reverseGradientColor ? gradient[0] : gradient[gradient.length - 1];
};

/**
 *  Return true if the chart setting's goal value is a number
 * @param {ChartSettingsT['goalValue']} goalValue - the goal value
 * @returns {boolean} - true if the goal value is a number
 */
export const getIsGoalValue = (goalValue: ChartSettingsT['goalValue']) =>
    goalValue && !Number.isNaN(parseFloat(goalValue.toString()));
